<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <div class="form-group">
    <label for="name">Название объекта</label>

    <input
      id="name"
      type="text"
      class="form-control"
      formControlName="name"
      autocomplete="off"
      autocorrect="off"
      enterkeyhint="done"
      spellcheck="false"
      [attr.aria-invalid]="isInvalid('name')"
      [attr.aria-describedby]="isInvalid('name') ? 'name-error' : null"
    />

    <small id="name-error" class="field-error" *ngIf="isInvalid('name')">
      Укажите название объекта
    </small>
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Отмена
    </button>

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      Сохранить
    </button>
  </div>
</form>
